import FacilitySurchargeBanner from './FacilitySurchargeBanner';

export default FacilitySurchargeBanner;
